/* eslint-disable react/no-multi-comp */
import { t } from 'i18next';

import AdelphiFieldsRow from '#components/business/AdelphiFieldsRow';

import { SPIRIT_SUBSTEPS_IDS } from './constants';
import styles from './styles.module.scss';

export const STILL_RUN_TITLES = {
  key: 'titles',
  Component: AdelphiFieldsRow,
  fieldContainerClassName: styles.stillRunTableColumns,
  fields: [
    {
      key: 'blankSpace',
      Component: () => <span />
    },
    {
      key: 'time',
      Component: () => (
        <span className={styles.stillRunTitle}>{t(`${SPIRIT_SUBSTEPS_IDS.STILL_RUN}:time`)}</span>
      )
    },
    {
      key: 'hydrometer',
      Component: () => (
        <span className={styles.stillRunTitle}>
          {t(`${SPIRIT_SUBSTEPS_IDS.STILL_RUN}:hydrometerReading`)}
        </span>
      )
    },
    {
      key: 'temp',
      Component: () => (
        <span className={styles.stillRunTitle}>{t(`${SPIRIT_SUBSTEPS_IDS.STILL_RUN}:temperature`)}</span>
      )
    }
  ]
};
